export default __webpack_public_path__ + "static/card1_img-024d119514b4abae63c623d8a91b3f42.webp";